<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="买手账号" prop="customerName">
            <el-input v-model="queryForm.customerName" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="4">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" @click="deleteAllBlackUsers()">
              全部删除</el-button>
            <el-button type="primary" size="small" @click="handleaddBlackUser('添加黑名单')">
              添加黑名单</el-button>
            <el-button type="primary" size="small" @click="handleImportData('导入黑名单')">
              导入黑名单</el-button>
            <el-button type="primary" size="small" @click="openModelDowload">
              模版下载</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="createTime" label="拉黑时间" />
      <el-table-column prop="customerId" label="买手ID" />
      <el-table-column prop="customerName" label="买手账号" />
      <el-table-column prop="plateformType" label="平台类型" />
      <el-table-column prop="blackBeacuse" label="拉黑原因" />
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" circle
                     @click="delBlackUser(scope.$index, scope.row)">
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <!--这是导入的对话框-->
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center;">
          <el-upload
              class="avatar-uploader"
              drag
              :action="baseServeUrl"
              :headers="myheader"
              :show-file-list="false"
              accept=".xlsx"
              :before-upload="onbeforeunloads"
              :on-success="importDataSuccess"
              :on-error="importDataError">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xlsx文件，且不超过50MB</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>

  <!--这是添加单个用户黑名单的对话框-->
  <el-dialog :title="dialogUpMoneyTitle" :visible.sync="dialogUpMoneyFormVisible">
    <el-form ref="dialogUpMoneyForm" :model="dialogUpMoneyForm" label-width="230px">
      <el-form-item label="试客用户名（必填）">
        <el-input v-model="dialogUpMoneyForm.userName" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="拉黑原因（必填）">
        <el-input v-model="dialogUpMoneyForm.beacuse" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="拉黑平台（可选）" >
        <el-select v-model="dialogUpMoneyForm.plateform" clearable placeholder="选择平台则只有这个平台不可接单否则全平台不可接" style="width: 50%;">
          <el-option
              v-for="item in plateforms"
              :key="item.id"
              :label="item.label"
              :value="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitBlackUserDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleBlackUserCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {addBlackUser, deleteAllBlackUser, deleteBlackUser, queryBlackUsers} from "../../api/b2cbusiness/b2c_blackuser";
import {getJwtToken} from "../../lib/utils";
import {backendServer} from "../../api";
import {Loading} from "element-ui";
export default {
  name: "BlackUserManagelist",
  mixins:[MixinCUD],
  data(){
    return {
      baseServeUrl:backendServer+"/b2cblackuser/blackuser/upload",
      myheader: {
        JWTHeaderName: ""
      },
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
        statusReviewDays:30,
        remarks:"",
        isOpenConf:false,
      },
      loadingInstance:null,
      dialogUpMoneyFormVisible: false,
      dialogUpMoneyTitle: "",
      dialogUpMoneyRefName: "dialogUpMoneyForm",
      dialogUpMoneyForm: {},
      plateforms: [
        {
          id: 1,
          label: "淘宝"
        },
        {
          id: 2,
          label: "京东"
        },
        {
          id: 3,
          label: "拼多多"
        },
        {
          id: 4,
          label: "抖音"
        },
        {
          id: 5,
          label: "阿里巴巴"
        }
      ],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    this.baseServeUrl = backendServer+"/b2cblackuser/blackuser/upload"
    this.getData();
  },
  methods: {
    openModelDowload(){
      window.open('https://myb2c.oss-cn-hangzhou.aliyuncs.com/dataimporttemplate/blackUsersImportTemplate.xlsx', "_blank");
    },
    onbeforeunloads(file){
      this.loadingInstance = Loading.service({text:"上传处理中"});
    },
    importDataSuccess(res, file){
      console.log(res, file);
      if (res.success){
        this.$message.success("导入数据成功");
        this.loadingInstance.close();
        this.dialogFormVisible = false;
        this.getData();
        this.$forceUpdate();
      }
    },
    importDataError(err, file, fileList){
      this.$message({message: err.message, type: 'error'});
      this.loadingInstance.close();
    },
    handleImportData(dialogTitle){
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
    },
    handleaddBlackUser(dialogTitle){
      this.dialogUpMoneyTitle = dialogTitle
      this.dialogUpMoneyFormVisible = true
    },
    submitBlackUserDialogForm(){
      addBlackUser(this.dialogUpMoneyForm).then(res=>{
        if (res.success){
          this.$message.success("添加成功！")
          this.dialogUpMoneyFormVisible = false
          this.getData()
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleBlackUserCloseDialog(){
      this.$refs[this.dialogUpMoneyRefName].resetFields();
      this.dialogUpMoneyFormVisible = false;
    },
    delBlackUser(index, row){
      deleteBlackUser(row.id).then(res=>{
        if (res.success){
          this.$message.success("全部删除成功！");
          this.getData();
        }
      });
    },
    deleteAllBlackUsers(){
      this.$confirm("确认删除所有数据？").then(_=>{
        deleteAllBlackUser().then(res=>{
          if (res.success){
            this.$message.success("全部删除成功！");
            this.getData();
          }
        });
      }).catch(err => {this.handleCloseDialog();});
    },
    getData(){
      queryBlackUsers(this.queryForm, this.pagination).then(res=>{
        if(res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      })
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
